module.exports = __webpack_public_path__ + "assets/img/typeB2.95da4894.png";